export const openInNewTab = (url: string) => {
    // 👇️ setting target to _blank with window.open
    if (window) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
};

export const naira = "₦";